import ajax from './ajax'
// 1.基础路径
const BASE_URL = '/api'
// const BASE_URL = 'http://119.23.153.13:8086'
// 用户名登录
export const pwdLogin=(username,password)=>ajax(BASE_URL+ '/login',{username,password},'POST');
// 退出登录
export const logout=()=>ajax(BASE_URL+ '/logout');
// 用户注册
export const getRegister=(username,password,phone,province,school,sxkm,zylb,wscore,zscore,year,cardNum,cardPwd,zxkma,zxkmb)=>ajax(BASE_URL+ '/registered',{username,password,phone,province,school,sxkm,zylb,wscore,zscore,year,cardNum,cardPwd,zxkma,zxkmb},'POST');
// 修改密码
export const updatePwd=(uid,password)=>ajax(BASE_URL+ '/modifyPassword',{uid,password},'POST');
// 忘记密码-找回密码
export const updateForgetPwd=(user)=>ajax(BASE_URL+ '/updatePWDByPhone', user, 'POST');
// 修改分数
export const updateScore =(yhid,gkfsxg,kl,zylb,wscore,zscore,zxkm)=>ajax(BASE_URL+ '/modifyScore',{yhid,gkfsxg,kl,zylb,wscore,zscore, zxkm},'POST');
// 根据ID获取用户信息
export const getUserInfo =(yhid)=>ajax(BASE_URL+'/getUserByid/' + yhid);
// 查询省市区
export const getAreaAll =(supercode,level,isopen)=>ajax(BASE_URL+'/queryAreaAll/' + supercode + '/'+ level +'/'+ isopen);
//获取学校
export const getSchool =(areacode)=>ajax(BASE_URL+ '/querySchoolAll/' + areacode);
// 加载专业类别
export const getZyTypes =()=>ajax(BASE_URL+ '/getType');
// 获取用户收藏院校
export const getCollectSchool =(params)=>ajax(BASE_URL+'/queryCollegeTableByUid/' + params.uid + "/" + params.pageNum);
// 添加院校收藏
export const addCollectSchool =(yhid,collegeid)=>ajax(BASE_URL+ '/addUserCollection',{uid:yhid,collegeid},'POST');
// 删除用户收藏院校
export const removeCollectSchool =(params)=>ajax(BASE_URL+ '/deleteUserCollection/' + (params.uid||params.yhid) + "/" + params.collegeid,{params},'DELETE');

// 批量删除全部收藏院校
export const removeCollectSchoolList =(uid)=>ajax(BASE_URL+ '/deleteAllCollection/' + uid,{},'DELETE');
// 查询商品信息
export const getProductinfo = ()=>ajax(BASE_URL+ '/artAliPay/getPrice');

// 在线购卡短息验证码
export const phoneMsg = (PhoneNumber)=>ajax(BASE_URL+ '/artMsg/aliMsg/' + PhoneNumber);
// 确认购买接口
export const confirmPurchase = (codeid,verification_code,PhoneNumber)=>ajax(BASE_URL+ '/artMsg/verification/' + codeid + "/"+ verification_code+"/"+PhoneNumber);
// 支付宝
export const zhifubaoPay = (PhoneNumber)=>ajax(BASE_URL+ '/artAliPay/pay/' + PhoneNumber);
// 微信
export const weixinPay = (PhoneNumber)=>ajax(BASE_URL+ '/artWxPay/pay/' + PhoneNumber);
// 微信支付是否成功
export const wxisSuccess = (out_trade_no)=>ajax(BASE_URL+ '/artWxPay/getOrder/' + out_trade_no);
// 招生计划
export const getPlanCondtion = ()=>ajax(BASE_URL+ '/epc/condtion');
// 查询计划结果
export const getPlanResult = (enrollmentPlan)=>ajax(BASE_URL+ '/epc/pageEnrollmentPlan',enrollmentPlan,'POST');
// 艺考生一分段结果
export const getYfdResult = (pageNum,nd,zylb,kl)=>ajax(BASE_URL+ '/epc/list/' + pageNum + '/' + nd + '/' + zylb + '/' + kl);
// 获取艺考生一分段条件
export const getNdList = ()=>ajax(BASE_URL+ '/epc/ndList');
export const getZyList = (nd)=>ajax(BASE_URL+ '/epc/zylbList',{nd});
export const getKlList = (nd)=>ajax(BASE_URL+ '/epc/klList',{nd});
// 获取文化生一分段结果
export const getWhYfdResult = (pageNum, nd, kl)=>ajax(BASE_URL+ '/epc/CulturalASegmentList/' + pageNum + '/' + nd + '/' + kl);
// 获取控制线
export const getKzxResult = (pageNum,nd,pc,kl,lb) =>ajax(BASE_URL+ '/epc/getKzxList/' + pageNum + '/' + nd + '/' + pc + '/' + kl + '/' + lb);
// 获取控制线查询条件
export const getKxzList = () =>ajax(BASE_URL+ '/epc/preGetKzx');
// 获取文化生一分段条件
export const getWhNdList = ()=>ajax(BASE_URL+ '/epc/CulturalNdList');
export const getWhKlList = ()=>ajax(BASE_URL+ '/epc/CulturalKlList');

// 专业列表
export const getMajorList = (xz)=>ajax(BASE_URL+ '/dp/getDis/' + xz);
// 查看专业详情
export const getMajorDetail = (zydm) => ajax(BASE_URL+ '/dp/getZYD/' + zydm);
// 专业开设院校
export const getMajorToSchool= (kl,zymc)=>ajax(BASE_URL+ '/dp/getDyx/'+ kl + "/"+ zymc);
// 院校查询
export const getSchoosFinder = (artSchool) => ajax(BASE_URL+ '/queryNew',artSchool,'POST');

// 修改批专业类别
export const updateKL = (kl) => ajax(BASE_URL+ '/updateKL/'+ kl);
export const updateZylb = (lb) => ajax(BASE_URL+ '/updateLB/'+ lb);

// 根据gbdm查询院校详情
export const getSchoolDetail = (gb,zyz,pc)=>ajax(
    BASE_URL+ '/querySchoolDetailed/'+ gb +'/'+ zyz+'/'+pc
    // BASE_URL+ '/querySchoolDetailed/'+ gb +'/'+ zyz
);
















                                            
